import { Component, inject, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { SummaryListComponent } from "../../../events/summary-list/feature/summary-list.component";
import { EventSystemHeadlineComponent } from "../../headline/feature/headline.component";
import { Store } from '@ngrx/store';
import { EventSystemActions } from '../../../data-services/stores/actions/event-system.actions';
import { selectEventSystem } from '../../../data-services/stores/selectors/event-systems.selectors';
import { CommonModule } from '@angular/common';
import { selectAllEventsBySystem } from '../../../data-services/stores/selectors/events.selectors';
import { EventActions } from '../../../data-services/stores/actions/events.actions';
import { Title } from '@angular/platform-browser';
import { tap } from 'rxjs';

@Component({
  selector: 'app-view',
  imports: [SummaryListComponent, EventSystemHeadlineComponent,CommonModule],
  templateUrl: '../ui/view.component.html',
  styleUrl: '../ui/view.component.css'
})
export class EventSystemViewComponent implements OnInit {
  private readonly _store = inject(Store);
  private readonly _route = inject(ActivatedRoute);
  private readonly _titleService = inject(Title);
  eventSystem$ = this._store.select(selectEventSystem(this._route.snapshot.params["id"])).pipe(
    tap(x => this._titleService.setTitle('LRPTickets.co.uk | ' + x?.name))
  );
  events$ = this._store.select(selectAllEventsBySystem(this._route.snapshot.params["id"]));

  ngOnInit(): void {
      this._store.dispatch(EventSystemActions.getSingleEventSystem({systemRef: this._route.snapshot.params["id"]}));
      this._store.dispatch(EventActions.loadAllEventsBySystem({systemRef: this._route.snapshot.params["id"]}));
      
  }
}
